import { app } from './app/app'

Object.assign(window, {
  app: app,
})
